export default __webpack_public_path__ + "static/media/circleBlue.b7a0e9d0.svg";